export default {
  gift_card_removed: 'Gift card removed',
  invalid_gift_card: 'Gift card is invalid',
  gift_card_applied: 'Gift card applied',
};
